import apiClient from './client'

export const dashboardAPI = {
  /**
   * Get dashboard statistics
   */
  getStats: async (startDate, endDate) => {
    const params = {}
    if (startDate) params.startDate = startDate
    if (endDate) params.endDate = endDate
    
    const response = await apiClient.get('/stats', { params })
    return response.data
  },

  /**
   * Get account information
   */
  getAccountInfo: async () => {
    const response = await apiClient.get('/account-info')
    return response.data
  },

  /**
   * Get wallet balance
   */
  getWalletBalance: async () => {
    const response = await apiClient.get('/wallet/balance')
    return response.data
  },

  /**
   * Get merchant settings (to check if payout is enabled)
   */
  getSettings: async () => {
    const response = await apiClient.get('/settings')
    return response.data
  },

  /**
   * Get login logs with pagination and filters
   */
  getLoginLogs: async (params = {}) => {
    const {
      page = 1,
      limit = 20,
      startDate,
      endDate,
      deviceType,
      browser,
    } = params

    const queryParams = new URLSearchParams()
    queryParams.append('page', page)
    queryParams.append('limit', limit)
    if (startDate) queryParams.append('startDate', startDate)
    if (endDate) queryParams.append('endDate', endDate)
    if (deviceType && deviceType !== 'all') queryParams.append('deviceType', deviceType)
    if (browser && browser !== 'all') queryParams.append('browser', browser)

    const response = await apiClient.get(`/login-logs?${queryParams.toString()}`)
    return response.data
  },

  /**
   * Get merchant name and wallet balances
   */
  getMerchantName: async () => {
    const response = await apiClient.get('/name')
    return response.data
  },
}

